import PaginationModule from './pagination.module'

export default PaginationModule
